module.exports = __webpack_public_path__ + "img/personal.8f5404c6.svg";